/**
 * Container for the "Usuarios y Equipos" tab inside the Organization page.
 * Splits the section into two sub-tabs: Usuarios | Equipos.
 */
import React, { useState } from 'react';
import { Tabs } from 'antd';
import { UserOutlined, TeamOutlined } from '@ant-design/icons';
import UsersManagementPanel from './UsersManagementPanel';
import TeamsManagementPanel from './TeamsManagementPanel';

const UsersAndTeamsPanel: React.FC = () => {
  const [tab, setTab] = useState<'users' | 'teams'>('users');

  return (
    <Tabs
      type="line"
      activeKey={tab}
      onChange={(k) => setTab(k as 'users' | 'teams')}
      items={[
        {
          key: 'users',
          label: <span><UserOutlined /> Usuarios</span>,
          children: <UsersManagementPanel />,
        },
        {
          key: 'teams',
          label: <span><TeamOutlined /> Equipos</span>,
          children: <TeamsManagementPanel />,
        },
      ]}
    />
  );
};

export default UsersAndTeamsPanel;
